import { render, staticRenderFns } from "./CompareEvents.vue?vue&type=template&id=045a6248&scoped=true"
import script from "./CompareEvents.vue?vue&type=script&lang=js"
export * from "./CompareEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045a6248",
  null
  
)

export default component.exports